module.exports = __webpack_public_path__ + "img/Intersect@2x-1.b27dc455.png";